import { CHANNELS } from './channels';

export const GOAL_KEY = 'GOAL';

export const MARKETPLACE = 'marketplace';

export const DOWNLOAD_FILE_NAME = 'Accuracy Trend Data.xls';

export const COMPONENT_GRAPH_ACCURACY_OPTION_KEYS = [
  'dailyCPAccuracyNV',
  'lastCPAccuracyNV',
  'dailyCPAccuracyAV',
  'lastCPAccuracyAV',
  'perUnitNetVarianceDailyCP',
  'perUnitNetVarianceLastCP',
  'perUnitVarianceDailyCP',
  'perUnitVarianceLastCP',
];

export const CHART_TYPE = Object.freeze({
  LINE: 'Line',
  BAR: 'Bar',
});

export const LEGEND_BY_CHANNEL = Object.freeze({
  [CHANNELS.MFN]: 'circle',
  [CHANNELS.FBA]: 'diamond',
  [CHANNELS.RETAIL]: 'square',
  [CHANNELS.ALL]: 'line',
  [CHANNELS.WD]: 'triangle',
  default: 'line',
});


// WEBPACK FOOTER //
// ./src/constants/trend_report.jsx